<template>
  <div>
    <div v-if="images.length > 0">
      <img
        class="image"
        :key="i"
        v-for="(image, i) in imgs"
        :src="image.thumburl"
        @click="onClick(i)"
      />
      <vue-gallery-slideshow
        :images="images"
        :index="index"
        @close="index = null"
      ></vue-gallery-slideshow>
    </div>
    <div v-else>
       <p>{{$t('Şəkil_tapılmadı')}}</p>
    </div>
  </div>
</template>

<script>
import VueGallerySlideshow from "vue-gallery-slideshow";
export default {
  components: {
    VueGallerySlideshow,
  },
  props: {
    stage: Number,
    id: String,
    images: Array,
  },
  data() {
    return {
      index: null,
      imgs: this.images,
    };
  },
  methods: {
    onClick(i) {
      this.index = i;
    },
  },
  watch: {
    images() {
      this.imgs = this.images;
    },
  },
};
</script>

<style>
.image {
  width: 130px;
  height: 130px;
  background-size: cover;
  cursor: pointer;
  margin: 5px;
  border-radius: 3px;
}
.vgs__gallery {
  display: none;
}
.vgs__container {
  height: auto !important;
}
.vgs {
  display: flex !important;
  align-items: center !important;
}
</style>